module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_6000.f22b966b.png";